import { useTranslation } from "react-i18next";

import { StateIcon } from "../../components/StateIcon";
import { ASSESSED_ORDER, stateColourVar, stateLabels } from "../stateMeta";

/**
 * Legend for the three assessed factor states, te reo first. Uses the shared
 * StateIcon (admin-customisable, colour-blind-safe glyphs) coloured via the
 * --state-* tokens.
 */
export function StateLegend() {
  const { t } = useTranslation();
  return (
    <ul className="rpt-legend" aria-label={t("reports.legendLabel")}>
      {ASSESSED_ORDER.map((k) => {
        const l = stateLabels(t, k);
        return (
          <li key={k} className="rpt-legend__item">
            <span
              className="rpt-legend__icon"
              style={{ color: stateColourVar(k) }}
            >
              <StateIcon state={k} />
            </span>
            <span className="rpt-legend__text">
              <span className="rpt-legend__reo" lang="mi">
                {l.reo}
              </span>
              <span className="rpt-legend__en">{l.en}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}

export default StateLegend;
